import { Injectable } from "@angular/core";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { environment } from "src/environments/environment";

@Injectable()
export class LoggingService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableCorsCorrelation: true,
        enableAutoRouteTracking: true,
        correlationHeaderExcludedDomains: ["maps.googleapis.com"],
      },
    });
    this.appInsights.loadAppInsights();
  }

  public logPageView(name?: string, url?: string): void {
    this.appInsights.trackPageView({ name: name, uri: url });
  }

  public logEvent(name: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  public logMetric(
    name: string,
    average: number,
    properties?: { [key: string]: any },
  ): void {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  public logException(exception: Error, severityLevel?: number): void {
    this.appInsights.trackException({
      exception: exception,
      severityLevel: severityLevel,
    });
  }

  public logTrace(message: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackTrace({ message: message }, properties);
  }

  public setUserContext(userId: string, roles: string[]): void {
    this.appInsights.setAuthenticatedUserContext(userId, roles.join(","));
  }

  public removeUserContext(): void {
    this.appInsights.clearAuthenticatedUserContext();
  }
}
